import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CommonDataStore } from './common-data.store';
import { Currency } from '../../models/common-data/currency';
import { DropdownItem } from '../../models/dropdown-item';

@Injectable()
export class CurrencyResolver implements Resolve<any> {

  constructor(private commonDataStore: CommonDataStore) {
  }

  // resolve(): Observable<Currency[]> {
  //   return this.commonDataStore.loadCurrencies();
  // }

  resolve(): Observable<DropdownItem[]> {
    return this.commonDataStore.loadCurrenciesDrop();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/common-data/currency.resolver.ts